import type { User } from '@privy-io/react-auth';

/**
 * Privy configuration and helpers shared by the provider, auth store and API client.
 */

export const PRIVY_APP_ID = (import.meta.env.VITE_PRIVY_APP_ID as string | undefined)?.trim() || '';
export const PRIVY_CLIENT_ID = (import.meta.env.VITE_PRIVY_CLIENT_ID as string | undefined)?.trim() || undefined;

export const privyConfigured = PRIVY_APP_ID.length > 0;

/** Normalised view of a Privy user for the rest of the app. */
export interface AuthUser {
  /** Privy DID, e.g. "did:privy:clxyz…". Used as `userId` on the server. */
  id: string;
  email?: string;
  name?: string;
}

export function toAuthUser(user: User): AuthUser {
  const email =
    user.email?.address ??
    user.google?.email ??
    user.apple?.email ??
    user.discord?.email ??
    user.linkedin?.email ??
    undefined;

  const name =
    user.google?.name ??
    user.twitter?.name ??
    user.discord?.username ??
    user.github?.name ??
    user.farcaster?.displayName ??
    user.linkedin?.name ??
    undefined;

  return {
    id: user.id,
    email: email?.toLowerCase(),
    name: name ?? undefined,
  };
}
